<template>
    <section class="text-white adolfo-home-bg">
        <b-container class="">
            <b-row style="top:80px; position:relative">
                <b-col sm="12" md="12" lg="6" style="margin-top: 120px;">
                    <h1 class="text-left font-weight-bold">
                        <span>MI</span> TRAYECTORIA
                    </h1>
                    <p class="text-left">
                        Lic. Adolfo R. Silva
                    </p>
                    <p class="text-left">
                        Egresado de la UIA Laguna Licenciatura en Comunicación.
                    </p>
                    <p class="text-left">
                        Ha sido Catedrático en diferentes universidades, e impartido conferencias en diversos foros.
                    </p>
                    <p class="text-left">
                        Experto en Marketing Político y de negocio consultor de marketing digital para empresas y
                        políticos.
                    </p>
                    <p class="text-left">
                        Inició su carrera en medios de comunicación colaborando en: Multimedios, TV Azteca,
                        Televisa Laguna y Diario La Opinión. Corresponsal Nacional del Radio Formula y Diario
                        Ovaciones. Director de Radio Torreón del 2008 al 2010. Actualmente es colaborador de
                        análisis político de Grupo Imagen.
                    </p>
                    <p class="text-left">
                        PREMIO ESTATAL DE PERIODISMO 2000 y PREMIO ESTATAL DE PERIODISMO 2001.
                    </p>
                    <p class="text-left">
                        Ha manejado Proyectos y Campañas de marketing durante 20 años para empresas como: Grupo
                        Modelo, Holcim Apasco, Coppel, Peñoles Ayuntamiento de Torreón, Ayuntamiento de Cuatro
                        Ciénegas, entre otros.
                    </p>
                    <p class="text-left">
                        Ha manejado campañas políticas a Gubernatura, Alcaldías, Diputaciones Federales.
                        Especialista en estrategias de marketing Político 360.
                    </p>
                    <p class="text-left">
                        Nominado en 12 ocasiones a los Premios Reed Latino de Marketing Político obteniendo los
                        siguientes galardones
                    </p>
                    <ul style="text-align: left">
                        <li>Bronce 2017 Mejor pieza Grafica</li>
                        <li>Oro 2018 Mejor Campaña de Contenido Social</li>
                        <li>Oro 2018 Mejor Spot Gubernamental</li>
                        <li>En 2019 Bronce Campaña 073</li>
                        <li>En 2020 Mejor campaña social</li>
                    </ul>

                </b-col>

            </b-row>
        </b-container>
    </section>
</template>

<script>
    export default {
        name: "Career"
    }
</script>

<style scoped>

</style>
